import moment from 'moment'

moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%ds',
    ss: '%ds',
    m: '%dm',
    mm: '%dm',
    h: '%dh',
    hh: '%dh',
    d: '%dd',
    dd: '%dd',
    M: '%dM',
    MM: '%dM',
    y: '%dY',
    yy: '%dY',
  },
})

export const getTime = (time) => {
  const days = moment().diff(moment(time), 'days')
  return days > 7
    ? moment(time)
        .format('DD MMM YY')
        .toUpperCase()
    : moment(time).fromNow()
}

export const getVerificationTitleAndCtaText = (userVerificationInfo) => {
  let title = 'Verify your phone and email'
  let cta = 'Verify now'
  if (
    userVerificationInfo.phoneVerified &&
    !userVerificationInfo.emailVerified
  ) {
    title = 'One last step! Verify email address'
    cta = 'Verify email'
  }
  if (
    !userVerificationInfo.phoneVerified &&
    userVerificationInfo.emailVerified
  ) {
    title = 'One last step! Verify phone number'
    cta = 'Verify phone'
  }

  return { title, cta }
}
